import React from "react";
import { debug, notImplemented } from "../../utils";
import { connect } from "react-redux";

function ChangeDetailsHeader({ hostName, mngtIpAddress }) {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="oct_toolbar-card">

                        <div className="oct_card-title">
                            <h2>{hostName}</h2>
                            <div className="oct_card-sub-title">{mngtIpAddress}</div>
                        </div>

                        <div className="oct_card-tools">
                            <div className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                Policy Details
                            </div>
                            <div className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                Refresh Configuration
                            </div>
                            <div className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                Modify Settings
                            </div>
                            <div className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                MSB Settings
                            </div>
                            <div className="oct_card-btn btn oct_btn-secondary" onClick={() => notImplemented()}>
                                Compliance
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ChangeDetailsHeader mapStateToProps", state);
    const device = state.changeDetailsPage.device;
    return {
        hostName: device ? device.hostName : '',
        mngtIpAddress: device ? device.mngtIpAddress : '',
    };
}

export default connect(mapStateToProps)(ChangeDetailsHeader);
